import { IDT } from '@ff-os/pdp-shared-redux/IDT';
import { DisplayMode } from '@ff-os/pdp-shared-redux/slices/globalSlice';
import { PhotoPrintsPdpDispatch } from '@ff-scene-plugins/photo-prints-redux/store';
import { setIsPhotoPrintsWindowOpen } from './_redux-ui';

export const show = (
    dispatch: PhotoPrintsPdpDispatch,
    containers: IDT.Containers,
    displayMode: DisplayMode
) => {
    dispatch(setIsPhotoPrintsWindowOpen(true));
};